(function($, Drupal) {
  'use strict';

  Drupal.behaviors.pppRgaa = {
    attach : function(context, settings) {
      window.rgaa = {
        'rgaaStyleNode' : undefined,
        'optionClasses' : {
          2 : 'rgaa-police-opendys',
          3 : 'rgaa-line-height-big'
        },
        'textStyleChanged' : false,
        'init' : function() {
          this.rgaaStyleNode = $("link[href*='ppp_theme-rgaa-reverse.css']");
          this.options = {
            1 : parseInt(sessionStorage.getItem('ppp_rgaa_modal_choice_1')) || 0, //contraste
            2 : parseInt(sessionStorage.getItem('ppp_rgaa_modal_choice_2')) || 0, //font
            3 : parseInt(sessionStorage.getItem('ppp_rgaa_modal_choice_3')) || 0  //line-height
          };
          this.updateModal();
        },
        'selectOption' : function(option, choice) {
          this.options[option] = parseInt(choice);
          this.updateModal();
        },
        'resetChoice' : function() {
          for (var option in this.options) {
            if (this.options.hasOwnProperty(option)) {
              this.options[option] = 0;
            }
          }
          this.updateModal();
        },
        'updateSession' : function() {
          for (var option in this.options) {
            if (this.options.hasOwnProperty(option)) {
              sessionStorage.setItem('ppp_rgaa_modal_choice_' + option, this.options[option]);
            }
          }
        },
        'updateModal' : function() {
          this.updateButton();
          this.updateOptionBind();
          this.updateSession();
        },
        'updateButton' : function() {
          // Disable button.
          $('.rgaa-modal .button-stack button')
            .removeClass('selected')
            .attr('tabindex', 0)
            .attr('aria-checked', false);

          // Enable selected options.
          for (var option in this.options) {
            if (this.options.hasOwnProperty(option)) {
              $('.rgaa-modal .button-stack button[data-option=' + option + '][data-choice=' +this.options[option] + ']')
                .addClass('selected')
                .attr('tabindex', -1)
                .attr('aria-checked', true);
            }
          }
        },
        'updateOptionBind' : function() {
          for (var option in this.options) {
            if (this.options.hasOwnProperty(option)) {
              if (option === '1') {
                if (this.options[option] === 1) {
                  if (this.rgaaStyleNode.length === 0) {
                    $('head').append(
                      '<link rel="stylesheet" media="all" href="' + settings.reverse_rgaa_css + '">');
                    this.rgaaStyleNode = $("link[href*='ppp_theme-rgaa-reverse.css']");
                  } else {
                    this.rgaaStyleNode.appendTo("head");
                  }
                } else {
                  if (this.rgaaStyleNode.length !== 0) {
                    this.rgaaStyleNode.detach();
                    this.rgaaStyleNode = "";
                  }
                }
              } else {
                if (this.options[option] === 1) {
                  $('body').addClass(this.optionClasses[option]);
                } else {
                  $('body').removeClass(this.optionClasses[option]);
                }
              }
            }
          }
          if (this.textStyleChanged && window.pppUpdatelineClamp) {
            this.textStyleChanged = false;
            if (window.updateLineClampTimeout) {
              clearTimeout(window.updateLineClampTimeout);
            }
            window.pppUpdatelineClamp();
          }
        }
      };

      $('.rgaa-modal .button-stack button').click(function() {
        if (this.dataset.option === '2' || this.dataset.option === '3') {
          window.rgaa.textStyleChanged = true;
        }
        window.rgaa.selectOption(this.dataset.option, this.dataset.choice);
      });

      $('.rgaa-modal .reset-button').click(function() {
        window.rgaa.resetChoice();
      });

      window.rgaa.init();
    }
  };

  Drupal.behaviors.pppScreenReaderHelper = {
    attach : function(context, settings) {
      // Redirect focus of event.target to "data-change-focus-to" value
      // "data-change-focus-to" should be the element id where the focus should
      // be redirected to
      $('[data-change-focus-to]').focus(function(event) {
        var target = $(event.target);
        var idElmntToFocus = $('#' + target.data('change-focus-to'));
        idElmntToFocus.get(0).focus();
      });

      var slider = $('#news-carousel');

      slider.focus(function() {
        $('.home-page-news-card').attr("tabindex", "-1");
        $('.slick-active .home-page-news-card').attr("tabindex", "0");
      });

      slider.on("afterChange", function() {
        $('.home-page-news-card').attr("tabindex", "-1");
        $('.slick-current .home-page-news-card').attr("tabindex", "0");
        $('.slick-current .home-page-news-card').focus();
      });

      $('.focused-carousel').focusout(function() {
        $('.focused-carousel').toggleClass('focused-carousel', false);
      });

      $('.news-carousel').focusin(function() {
        $(this).toggleClass('focused-carousel', true);
      });

      function updateCarouselAria() {
        setTimeout(function() {
          $('.focused-carousel .js-slide-body').attr("tabindex", "-1");
          $('.focused-carousel .field-paragraph--field-common-link a').attr("tabindex", "-1");

          $('.focused-carousel .slick-current .js-slide-body').attr("tabindex", "0");
          $('.focused-carousel .slick-current .field-paragraph--field-common-link a').attr("tabindex", "0");
          $('.focused-carousel .slick-current .js-slide-body').focus();
        }, 400);
      }

      // init current slide
      $('.news-carousel .slick-current .js-slide-body').attr("tabindex", "0");
      $('.news-carousel .slick-current .field-paragraph--field-common-link a').attr("tabindex", "0");

      $(document).on('keydown', function(event) {
        var pressedKeyCode = event.which;
        if (pressedKeyCode === 39 || pressedKeyCode === 37) {
          if ($('.news-carousel').hasClass('focused-carousel')) {
            var focusedCarousel = $('.news-carousel.focused-carousel');

            if (pressedKeyCode === 39) {
              // right arrow
              focusedCarousel.slick('slickNext');
              updateCarouselAria();
            } else {
              // left arrow
              focusedCarousel.slick('slickPrev');
              updateCarouselAria();
            }
          }
        }
      });

      $('.trigger-click').on('keydown', function(e) {
        if (e.which === 13 || e.which === 32) {
          $(this).click();
        }
      });

    }
  };

})(jQuery, Drupal);
